/**
 * SumDisplay Component
 * Displays a single KPI-style aggregated number
 */

import React from 'react';
import { Typography, Paper } from '@mui/material';
import type { SumDataDto } from '@/api/types/dtos/analytics/AnalyticsDto';

interface SumDisplayProps {
  data: SumDataDto;
  onClick?: (value: string) => void;
}

export const SumDisplay: React.FC<SumDisplayProps> = ({ data }) => {
  // Safety check for data
  if (!data) {
    return (
      <Paper
        sx={{
          height: 180,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          bgcolor: 'var(--tertiary)',
          borderRadius: 'var(--card-border-radius)',
          border: '1px solid var(--border-color)',
        }}
      >
        <Typography sx={{ color: 'var(--text-secondary)' }}>No data available</Typography>
      </Paper>
    );
  }

  return (
    <Paper
      sx={{
        height: 180,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: 'var(--tertiary)',
        borderRadius: 'var(--card-border-radius)',
        border: '1px solid var(--border-color)',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          color: 'var(--primary)',
          fontWeight: 700,
        }}
      >
        {typeof data.value === 'number' ? data.value.toLocaleString() : data.value}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{
          color: 'var(--text-primary)',
          mt: 1,
          fontWeight: 500,
        }}
      >
        {data.label}
      </Typography>
    </Paper>
  );
};